import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Grid } from 'antd';
import { ArrowRightOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { useActiveCart } from '@core/hooks/useCart';
import Price from '@components/base/Price';
import { useCopy } from '@/app/providers/useCopy';

export default function MobileCartBarCoffee() {
  const t = useCopy();
  const navigate = useNavigate();
  const location = useLocation();
  const screens = Grid.useBreakpoint();
  const hasResolvedBreakpoint = Object.keys(screens).length > 0;
  const isMobile = hasResolvedBreakpoint && !screens.sm;
  const { cart, lineCount } = useActiveCart();
  const { pathname } = location;

  const isDrawerOpen =
    typeof document !== 'undefined' &&
    (document.body.classList.contains('cart-drawer-open') ||
      document.documentElement.classList.contains('cart-drawer-open'));

  const isVisible =
    isMobile && lineCount > 0 && pathname !== '/cart' && pathname !== '/checkout' && !isDrawerOpen;

  useEffect(() => {
    document.documentElement.classList.toggle('coffee-mobile-cart-bar-active', isVisible);
    return () => {
      document.documentElement.classList.remove('coffee-mobile-cart-bar-active');
    };
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  const handleOpenCart = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    navigate('/cart');
  };

  const totalPrice = cart?.grandTotal ?? cart?.subtotal ?? 0;

  return (
    <div
      className="coffee-mobile-cart-bar"
      onClick={handleOpenCart}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleOpenCart(e);
        }
      }}
    >
      <div className="coffee-mobile-cart-bar__meta">
        <ShoppingCartOutlined className="coffee-mobile-cart-bar__icon" />
        <div className="coffee-mobile-cart-bar__info">
          <strong>
            {lineCount} {lineCount === 1 ? t('item', 'item') : t('items', 'items')}
          </strong>
          <div className="coffee-mobile-cart-bar__price">
            <Price amount={totalPrice} color="#ffffff" />
          </div>
        </div>
      </div>
      <button type="button" className="coffee-mobile-cart-bar__cta" onClick={handleOpenCart}>
        <span>{t('basket', 'Basket')}</span>
        <ArrowRightOutlined />
      </button>
    </div>
  );
}
